// Copyright (C) 2021 Bystronic Laser AG

import { CareAlertMetric, AlertOperator } from './enums/AlertsEnums';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';

export interface StandardAlert {
  // "Number" in the UI
  id: number;
  status: StandardAlertStatus;
  name: string;
  description: string | null;
  severity: StandardAlertSeverity;
  // KPI
  metric: CareAlertMetric;
  operator: AlertOperator;
  threshold: number;
  dateGrouping: FilterTimeAxisSpanEnum;
  eventSources: string[];
  eventCodes: string[];
  variable: string | undefined;
  deactivationDate: Date | null;
  deactivatedBy: string | null;
  createdBy: string;
  modifiedBy: string;
  modifiedDate: Date;
}

export enum StandardAlertStatus {
  Draft = 1,
  Active = 2,
  InUse = 3,
  Inactive = 4,
}

export enum StandardAlertSeverity {
  Low = 1,
  Medium = 2,
  High = 3,
}
